import { useIdleLogout } from "./use-idle-logout";

/** Monta o logout por inatividade; não renderiza nada. Só deve existir em rota autenticada. */
export function IdleLogout() {
  useIdleLogout();
  return null;
}
